/**
 * Sprint V100+ · Value-Bridge-Content (18.09.2026)
 *
 * Content-Bausteine für die Ergebnis-Seite des QuickChecks.
 * Ziel: „Aha, das bin ich"-Moment + Pain-Recognition + Quick-Tip
 * VOR dem Registrierungs-CTA. Balance: genug Value, dass der User
 * mitgeht — nicht so viel, dass der Free-Cockpit-Wert verwässert wird.
 *
 * Alle Inhalte sind bewusst KURZ. Die vollen Charakter-Texte,
 * 3-Satz-Brücken und Detail-Analysen bleiben im Free-Cockpit.
 */

// Slot 1 — SPIEGEL: 1 Satz Wiedererkennung
export const SPIEGEL_BY_FOKUSTYP = {
  eule:
    "Du willst verstehen, warum etwas sinnvoll ist — bevor du mitmachst.",
  biene:
    "Du willst wissen, wie etwas geht — Schritt für Schritt, mit klarem Plan.",
  katze:
    "Du willst spüren, ob etwas zu DIR passt — bevor du Energie reinsteckst.",
  hund:
    "Du willst wissen, wer mit dir spricht — bevor du dich auf die Sache einlässt.",
};

// Slot 2 — PAIN: eine empathische Erkennungs-Frage
export const PAIN_QUESTION_BY_FOKUSTYP = {
  eule:
    "Passiert es dir öfter, dass du eine Sache nicht angehst, solange du den Sinn nicht siehst — und dabei Chancen ziehen lässt?",
  biene:
    "Kennst du das Gefühl, dass du am liebsten noch feilen würdest — obwohl es längst gut genug ist?",
  katze:
    "Passiert es dir immer wieder, dass du bei Aufgaben, die sich nicht \u201Enach dir\u201C anfühlen, innerlich aussteigst — und dann selber unzufrieden bist?",
  hund:
    "Kennst du das: Du gehst auf andere zu und wartest auf Bestätigung — die dann ausbleibt, weil das Gegenüber sie gar nicht braucht?",
};

// Slot 3 — QUICK-TIP: konkret + umsetzbar, ohne die volle 3-Satz-Brücke zu leaken
export const QUICK_TIP_BY_FOKUSTYP = {
  eule:
    "Nächstes Mal, wenn du sofort \u201Edas ist unsinnig\u201C denkst — halt den Impuls kurz. Frag dich: Was würde ich sehen, wenn es doch Sinn hätte? Das öffnet Türen, die dein Kritik-Reflex sonst gleich zumacht.",
  biene:
    "Nächstes Mal, wenn du am Plan feilst — setz dir einen Wecker auf 5 Minuten. Wenn er klingelt, geh in die Umsetzung, nicht in Runde 2 der Optimierung.",
  katze:
    "Nächstes Mal, wenn du innerlich rausgehst — sag dir laut EINEN Grund, warum DU es machen wollen könntest. Nicht \u201Eweil man muss\u201C. Deiner.",
  hund:
    "Nächstes Mal, wenn du im Team etwas brauchst — sag es direkt. Ohne Beziehungs-Vorlauf. Das fühlt sich unhöflich an, ist aber genau, was dein Gegenüber braucht.",
};

// Slot 4 — CTA-Feature-Liste: was der User im Free-Bereich WIRKLICH bekommt.
// V100+ Iteration 4b (18.09.2026) — nur reale Free-Features, kein Overpromise:
//  • Steckbrief = eigener Fokustyp-Charakter (bestätigt in Free)
//  • Ergebnis-Persistenz = Zugriff auf QuickCheck-Ergebnis jederzeit
//  • Cockpit = persönlicher Bereich
// NICHT versprochen (weil ProSolo oder nicht existent):
//  3-Satz-Brücken, 20-Fragen-Detail-Check, Wöchentlicher Tipp, alle 4 Steckbriefe
// Sprint V101.g (So 20.09.2026, Andreas) — Wörterwahl vereinheitlicht auf
// „Cockpit" statt „Bereich" (App-Assoziation stärken, Erwartung matcht
// spätere Realität). Reihenfolge unverändert.
export const FREE_COCKPIT_FEATURES = [
  "Dein persönlicher Fokustyp-Steckbrief — ein Spiegel deines Musters",
  "Dein Ergebnis dauerhaft gespeichert — jederzeit im Mitgliederbereich abrufbar",
  "Zugang zu deinem persönlichen PocketCoach, wenn du tiefer einsteigen willst",
];
